import Cookies from 'js-cookie';
import Audio5js from 'audio5';
import crypto from 'crypto';

import { Toast } from 'mint-ui';
import * as types from '@/store/mutation-types';
import { healthSign } from '@/store/action.util';
import { browser } from '@/lib/ua';
import { util } from '@/lib/utils';
import { getApi, postApi } from '../../comm/middleware/callApi';
import apis from '../../comm/api/apis';
import { updateAjaxHeaderConfig } from '../../comm/api';
import * as model from '../../comm/model/';
import { throwIfMissing, updateLoginInfo } from '../../comm/utils';
import reportLog from '../../comm/middleware/reportLog';

export * from './dayima/actions.dayima';
export * from './knowing/actions.knowing';
export * from './lighthouse/actions.lighthouse';

// 获取后台配置的静态数据
let hasFish = false;
export const getConstantData = ({ commit, state }, { typesNum, version }) => {
  if (hasFish) {
    return Promise.resolve();
  }
  hasFish = true;
  return getApi({ commit }, apis.constantData, { types: typesNum, version })
    .then((body) => {
      const constantData = body.data;
      commit(types.AJAX_GET_CONSTANT_DATA, {
        constantData
      });
      return body.data;
    }).catch(() => {
      hasFish = false;
    });
};

// 根据宝宝树用户id生成loginStr
export const getUserLoginStr = ({ commit }, { encuserid }) => {
  return getApi({ commit }, apis.getUserLoginStr, { encuserid })
    .then((data) => {
      return data.data;
    });
};

// 登录后获取会员信息
export const getMemberInfo = ({ commit, state }, userInfo, updateMember = true) => {
  updateLoginInfo({ token: userInfo.token, userInfo });
  // 接口传入前先插入一次用户信息
  const afterUserInfo = model.userInfo(userInfo);
  commit(types.AJAX_GET_USERINFO, { userInfo: afterUserInfo });
  Cookies.set('userInfo', afterUserInfo);

  if (updateMember || !userInfo.member) {
    getApi({ commit }, apis.queryUserMemberInfo).then((info) => {
      userInfo.nickName = info.data.name;
      userInfo.avatar = info.data.headImgUrl;
      const formatUserInfo = model.userInfo(userInfo, info.data);
      commit(types.AJAX_GET_USERINFO, { userInfo: formatUserInfo });
      Cookies.set('userInfo', formatUserInfo);
    });
  } else {
    const formatUserInfo = model.userInfo(userInfo, userInfo.member);
    commit(types.AJAX_GET_USERINFO, { userInfo: formatUserInfo });
    Cookies.set('userInfo', afterUserInfo);
  }
  if (state.constantData.length === 0) {
    getConstantData({ commit }, {
      typesNum: '5',
      version: '1'
    });
  }
};

// 用户授权
export const userAuth = (store, { code, userInfo = null, platformType = 5 }) => {
  const commit = store.commit;
  commit(types.AJAX_LOADING, { loadingStatus: true });
  if (browser.wx) {
    // 在微信端，需要 code
    if (code) {
      // 如果从复兴网红医生进入课程
      const fxUserInfo = Cookies.get('userInfo') ? JSON.parse(Cookies.get('userInfo')) : null;
      let userSource = 1;
      if (fxUserInfo) {
        userSource = fxUserInfo.userSource;
      }
      if (userSource === 0) {
        // 复星来源 认证接口
        getApi({ commit }, apis.wxAuthFx, { platformType, code }).then((info) => {
          // 获取后台筛入cookie里的用户信息
          fxUserInfo.weixinUserInfo = info;
          getMemberInfo(store, fxUserInfo);
          healthSign(store, { userType: 'user', token: info.token });
        });
      } else {
        getApi({ commit }, apis.wxAuth, { code, platformType }, {}, false, true).then((body) => {
          const info = body.user[0];
          info.weixinUserInfo = body.weixinUserInfo;
          getMemberInfo(store, info);
          healthSign(store, { userType: 'user', token: info.token });
        });
      }
    } else if (userInfo) {
      // 如果从复兴网红医生进入课程

      const userSource = userInfo.userSource;
      const hasOpenId = userInfo.weixinUserInfo ? userInfo.weixinUserInfo.openid : 0;
      if (userSource === 0) {
        if (hasOpenId) {
          getMemberInfo(store, userInfo);
          healthSign(store, { userType: 'user', token: userInfo.token });
        }
      } else {
        getMemberInfo(store, userInfo);
        healthSign(store, { userType: 'user', token: userInfo.token });
      }
    }
  } else {
    // 在非微信端，需要 mttoken
    let mtTokenStr = Cookies.get('mttoken') ? Cookies.get('mttoken') : null;

    commit(types.AJAX_LOADING, { loadingStatus: false });

    // TODO: 特殊处理,MT_USER_INFO 代表手机登陆
    if (userInfo && !Cookies.get('MT_USER_INFO')) {
      getMemberInfo(store, userInfo);
      healthSign(store, { userType: 'user', token: userInfo.token });
    } else if (mtTokenStr && !Cookies.get('MT_USER_INFO')) {
      const info = {
        token: mtTokenStr,
        encUserId: Cookies.get('mtencUserId') ? Cookies.get('mtencUserId') : null,
        avatar: Cookies.get('mtavatar') ? Cookies.get('mtavatar') : null,
        nickName: Cookies.get('mtname') ? Cookies.get('mtname') : null,
        isHaveMobile: Cookies.get('mtisHaveMobile') ? Cookies.get('mtisHaveMobile') : null
      };
      getMemberInfo(store, info);
      healthSign(store, { userType: 'user', token: info.token });
    } else if (Cookies.get('MT_USER_INFO')) {
      // app端，获取用户信息,没有H5讲课
      // mobile[0] version[1] token[3] telphone[4] userId[5]
      const allCookies = Cookies.get();
      const fck = allCookies.MT_USER_INFO.split(',');
      mtTokenStr = util.base64Decode(fck[3]);
      const info = {
        token: mtTokenStr,
        encUserId: util.base64Decode(fck[5]),
        avatar: null,
        nickName: '',
        isHaveMobile: util.base64Decode(fck[4]) ? 1 : 0
      };
      if (mtTokenStr) {
        getMemberInfo(store, info);
      } else {
        Cookies.set('userInfo', '', { expires: -1 });
        window.localStorage.removeItem('userinfo');
      }
    }
  }
};

export const getHotLabel = ({ commit }, labeltype) => {
  getApi({ commit }, apis.hotLabel, { labeltype }).then((body) => {
    commit(types.AJAX_HOT_LABEL_LIST, body.data.hotLabelList);
  });
};

// 课程下单
export const courseBuy = ({ commit }, { courseId, type = '1', paywayid = '4', pointpromid, distributionuserid, postuserid, postid, activityid }) => {
  return getApi({ commit }, apis.buy, {
    courseid: courseId,
    type,
    paywayid,
    pointpromid,
    distributionuserid,
    postuserid,
    postid,
    activityid
  }).then((body) => {
    const buyInfo = body.data;
    commit(types.AJAX_BUY_INFO, { buyInfo }); // 已无用
    return buyInfo;
  });
};

// 课程购买
export const coursePay = ({ commit }, { orderCode, type = '1', paywayid = '4', openid, wappayresultpage, quiturl }) => {
  return getApi({ commit }, apis.pay, {
    ordercode: orderCode,
    type,
    paywayid,
    openid,
    wappayresultpage,
    quiturl,
    weixinappcode: 'wx5699bb5297ae3984'
  }).then((body) => {
    commit(types.AJAX_PAY_INFO, { payInfo: body.data }); // 已无用
    return paywayid === 16 ? body : body.data;
  });
};

// 获取预提交订单信息
export const getPreOrderInfo = ({ commit }, { courseId, type = '1', parentcourseid, pointpromid, activityid }) => {
  if (activityid) {
    return getApi({ commit }, apis.jxjOrder, { courseid: courseId, type, parentcourseid, pointpromid, activityid })
    .then((body) => {
      commit(types.AJAX_ORDER_INFO, {
        preOrderInfo: body.data
      });
      return body.data;
    });
  }
  return getApi({ commit }, apis.order, { courseid: courseId, type, parentcourseid, pointpromid })
    .then((body) => {
      commit(types.AJAX_ORDER_INFO, {
        preOrderInfo: body.data
      });
      return body.data;
    });
};


function submitForm(action, params) {
  // 如果支付协议为http协议,强制把协议改成https协议
  if (action && action.startsWith('http:')) {
    action = action.replace('http:', 'https:');
  }

  const formEl = document.querySelector('form[name=to-pay-form]');
  if (formEl) {
    const parentNode = formEl.parentNode;
    parentNode.removeChild(formEl);
  }
  const aliForm = document.createElement('form');
  aliForm.name = 'to-pay-form';
  aliForm.action = action;
  aliForm.method = 'get';
  aliForm.target = '_self';
  document.body.appendChild(aliForm);
  // params.req_data = params.req_data.replace(/</g, '&#60;').replace(/>/g, '&#62;');
  Object.keys(params).forEach((key) => {
    const aliInput = document.createElement('input');
    aliInput.type = 'hidden';
    aliInput.name = key;
    aliInput.value = params[key];
    aliForm.appendChild(aliInput);
  });
  aliForm.style.display = 'none';
  aliForm.submit();
}

// 蚂蚁支付
export const courseMaYiPay = ({ commit }, { payInfo, type }) => {
  const payParams = {
    sign: payInfo.sign,
    sec_id: payInfo.secId || payInfo.sec_id,
    v: payInfo.v,
    req_data: payInfo.reqData || payInfo.req_data,
    service: payInfo.service,
    partner: payInfo.partner,
    format: payInfo.format
  };
  const actionUrl = type === 2 ? payInfo.actionurl : payInfo.actionUrl;
  submitForm(actionUrl, payParams);
};

// 支付宝支付成功
export const getMaYiPayStatus = ({ commit }, { payInfo, status }) => {
  commit(types.MY_PAY, { payInfo, status });
};

// 微信支付
export const courseWxPay = ({ commit }, { payInfo }) => {
  // window.wx.chooseWXPay({
  //   timestamp: payInfo.timeStamp,
  //   nonceStr: payInfo.noncestr, // 支付签名随机串，不长于 32 位
  //   package: payInfo.wxPackage, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
  //   signType: payInfo.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
  //   paySign: payInfo.signedinfo, // 支付签名
  //   success: (res) => {
  //     console.log(res);
  //     commit(types.WX_PAY, { payInfo, status: 1 });
  //   },
  //   fail: (res) => {
  //     console.log(res);
  //     commit(types.AJAX_ERROR, new Error('微信支付失败，请重试'));
  //     commit(types.WX_PAY, { payInfo, status: 0 });
  //     res.time = new Date().toString();
  //     window.localStorage.setItem('wxPayError', JSON.stringify(res));
  //   },
  // });
  function onBridgeReady() {
    window.WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        appId: payInfo.appid,               // 公众号名称，由商户传入
        timeStamp: payInfo.timeStamp,       // 时间戳，自1970年以来的秒数
        nonceStr: payInfo.noncestr,         // 随机串
        package: payInfo.wxPackage,
        signType: payInfo.signType,         // 微信签名方式：
        paySign: payInfo.signedinfo        // 微信签名
      },
      (res) => {
        console.log('courseWxPay', res);
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          commit(types.WX_PAY, { payInfo, status: 1 });
        }
        // 用户支付途中取消
        if (res.err_msg === 'get_brand_wcpay_request:cancel') {
          commit(types.AJAX_ERROR, new Error('支付失败，已取消'));
        }
        // 用户支付失败
        if (res.err_msg === 'get_brand_wcpay_request:fail') {
          commit(types.AJAX_ERROR, new Error('微信支付失败，请重试'));
          commit(types.WX_PAY, { payInfo, status: 0 });
          res.time = new Date().toString();
          window.localStorage.setItem('wxPayError', JSON.stringify(res));
          reportLog(Object.assign(res, payInfo)).then(() => {
            console.log('日志-微信支付失败');
          });
        }
        if (res.errMsg) {
          commit(types.AJAX_ERROR, new Error(res.errMsg));
        }
      },
    );
  }
  if (typeof window.WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};
// 支付成功后清除支付状态，避免逻辑混乱
export const clearPayStatus = ({ commit }) => {
  commit(types.CLEAR_PAY_STATUS);
};

// 添加评论
export const addComment = ({ commit }, { courseId, professionalDegree, informationDegree, experienceDegree, recommend, content }) => {
  const params = {
    courseid: courseId,
    professionaldegree: professionalDegree,
    informationdegree: informationDegree,
    experiencedegree: experienceDegree,
    recommend,
    content
  };
  return getApi({ commit }, apis.addComment, params)
  .then((body) => {
    commit(types.AJAX_POST_ADDCOMMENT, { commentId: body.data.courseId });
    return body;
  });
};

// 用户端首页获取分类列表
export const getCatagory = ({ commit }) => {
  getApi({ commit }, apis.getCatagoryUrl)
    .then((body) => {
      commit(types.AJAX_GET_CATAGORY, { list: body.data });
    });
};

// 用户端首页列表
export const getIndexList = ({ commit },
  {
    pagesize = 10,
    catagoryId,
    curpage,
    startStatus,
    newPage
  }) => {
  getApi({ commit }, apis.indexListUrl, { catagoryId, pagesize, curpage, startStatus })
    .then((body) => {
      commit(types.AJAX_GET_INDEXLIST, { indexData: body.data, newPage });
    });
};

// 课程点赞
export const courseLike = ({ commit, state }, { like = true, courseId }) => {
  commit(types.SOCKET_RECEIVE_MESSAGE_UP, {
    courseUpCount: Number(state.courseUpCount) + 1
  });
  getApi({ commit }, apis.courseLike, { courseId, like }, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } });
};

// 小微课程点赞
export const xwCourseLike = ({ commit, state }, { courseId, isLoading = true }) => {
  // ??? 这里调了接口就完了？
  getApi({ commit }, apis.xwCourseLike, { courseId }, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } }, isLoading);
};

// 消息点赞
export const messageLike = ({ commit }, { courseId, msgId, count, likeType = 'message' }) => {
  commit(types.SOCKET_RECEIVE_MESSAGE_LIKE_COUNT, {
    msgId,
    count,
    likeType
  });

  // todo 原接口请求用的是form
  getApi({ commit }, apis.messageLike, { messageId: msgId, courseId }, { headers: { 'Content-type': 'application/x-www-form-urlencoded' } })
    .then(() => {
      commit(types.SOCKET_RECEIVE_MESSAGE_LIKE_COUNT, {
        msgId,
        count,
        likeType
      });
    });
};

// 获取问题库列表 - 热门提问 和 我的提问
export const getUserIssues = ({ commit }, { condition = 1, courseId, lastId }) => {
  getApi({ commit }, apis.userIssues, { courseId, condition, lastId })
    .then((body) => {
      commit(types.AJAX_GET_USER_ISSUES, { issues: body.data, lastId });
    });
};

// 用户端我的开讲
export const getUserCourses = ({ commit }, { pagesize = 10, curpage = 1, coursetype, newPage }) => {
  getApi({ commit }, apis.UserCourses, { pagesize, curpage, coursetype })
    .then((body) => {
      commit(types.AJAX_GET_USERCOURSE, { courseData: body.data, newPage, coursetype });
    });
};

// 用户端我的组合课
export const getCombineCourses = ({ commit }, { pagesize = 10, curpage = 1, newPage }) => {
  getApi({ commit }, apis.combinecourses, { pagesize, curpage })
    .then((body) => {
      commit(types.AJAX_GET_COMBINECOURSE, { courseData: body.data, newPage });
    });
};

// 用户端完善资料-发送验证码
export const getTheCode = ({ commit }, { type = 2, telephone }) => {
  postApi({ commit }, apis.verifycode, { telephone, type })
    .then((body) => {
      commit(types.AJAX_POST_USERSENDCODE, { sedCodeInfo: body });
    });
};
// 用户端完善资料-绑定手机号
export const getBindMobile = ({ commit },
                              {
                                token = throwIfMissing('token 参数不能为空'),
                                telephone = throwIfMissing('telNum 参数不能为空'),
                                captcha = throwIfMissing('captcha 参数不能为空'),
                                unionid = throwIfMissing('unionid 参数不能为空')
                              }) => {
  return getApi({ commit }, apis.bindMobile, { token, mobile: telephone, smsCode: captcha, unionid })
    .then((body) => {
      commit(types.AJAX_POST_USERBINDING, { bindMobileInfo: body });
      updateAjaxHeaderConfig({ token: body.user[0].token });
      return body;
    });
};

/**
 * 用户端 - 我的音频/视频
 * @param commit
 * @param coursetype 9: 视频 10: 视频专辑 3: 音频 4: 音频专辑
 * @param pagesize
 * @param curpage
 */
function getMyTinyCourses({ commit }, { coursetype = throwIfMissing('coursetype 参数不能为空'), pagesize = 10, curpage = 1 }) {
  return getApi({ commit }, apis.myTinyCourses, { coursetype, pagesize, curpage })
    .then((body) => {
      return body.data;
    });
}

// 用户端 - 我的音频 - 音频
export const getMyTinyAudio = ({ commit }, { pagesize, curpage }) => {
  getMyTinyCourses({ commit }, { coursetype: 3, pagesize, curpage })
    .then((data) => {
      commit(types.AJAX_GET_MYTINYAUDIO, { myTinyAudio: data, curpage });
    });
};

// 用户端 - 我的音频 - 专辑
export const getMyTinyAlbum = ({ commit }, { pagesize, curpage }) => {
  getMyTinyCourses({ commit }, { coursetype: 4, pagesize, curpage })
    .then((data) => {
      commit(types.AJAX_GET_MYTINYALBUM, { myTinyAlbum: data, curpage });
    });
};


// 用户端 - 我的视频 - 视频
export const getMyTinyVideo = ({ commit }, { pagesize, curpage }) => {
  getMyTinyCourses({ commit }, { coursetype: 9, pagesize, curpage })
    .then((data) => {
      commit(types.AJAX_GET_MYTINYVIDEO, { myTinyVideo: data, curpage });
    });
};
// 用户端 - 我的视频 - 专辑
export const getMyTinyVideoAlbum = ({ commit }, { pagesize, curpage }) => {
  getMyTinyCourses({ commit }, { coursetype: 10, pagesize, curpage })
    .then((data) => {
      commit(types.AJAX_GET_MYTINYVIDEOALBUM, { myTinyVideoAlbum: data, curpage });
    });
};

// 用户端-全局音频
export const initAudio = ({ commit, state }, audioObj) => {
  const oldAudio5 = state.audio5;
  if (oldAudio5) {
    oldAudio5.destroy();
  }
  const audio5 = new Audio5js({
    throw_errors: false,
    format_time: true,
    ready() {
      this.load(audioObj.url);
      this.one('canplay', () => {
        commit(types.AJAX_UPDATE_AUDIO5, { audio5, audioObj });
        audioObj.canplay(audio5);
      }, this);
      this.one('ended', () => {
        audioObj.ended();
      }, this);
      this.one('error', (error) => {
        commit(types.AJAX_ERROR, error);
        audioObj.error();
      }, this);
    }
  });
};

// 用户端 - 组合课程列表
export const getGroupAlbum = ({ commit }, { pagesize = 10, curpage = 1 }) => {
  getApi({ commit }, apis.combineList, { pagesize, curpage })
    .then((body) => {
      const groupAlbum = body.data;
      commit(types.AJAX_GET_GROUPALBUM, { groupAlbum, curpage });
    });
};

// 收银台支付 - 目前处理其他平台过来的微信支付
export const cashierPay = ({ commit }, { payInfo }) => {
  function onBridgeReady() {
    window.WeixinJSBridge.invoke(
      'getBrandWCPayRequest', {
        appId: payInfo.appid,               // 公众号名称，由商户传入
        timeStamp: payInfo.timeStamp,       // 时间戳，自1970年以来的秒数
        nonceStr: payInfo.noncestr,         // 随机串
        package: payInfo.wxPackage,
        signType: payInfo.signType,         // 微信签名方式：
        paySign: payInfo.signedinfo        // 微信签名
      },
      (res) => {
        console.log('courseWxPay', res);
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          commit(types.CASHIER_PAY, { status: 1 });
        }
        // 用户支付途中取消
        if (res.err_msg === 'get_brand_wcpay_request:cancel') {
          commit(types.CASHIER_PAY, { status: 2 });
        }
        // 用户支付失败
        if (res.err_msg === 'get_brand_wcpay_request:fail') {
          commit(types.CASHIER_PAY, { status: 0 });
        }
        if (res.errMsg) {
          commit(types.CASHIER_PAY, { status: 0 });
        }
      },
    );
  }
  if (typeof window.WeixinJSBridge === 'undefined') {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
      document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
    }
  } else {
    onBridgeReady();
  }
};

// 小时光更多免费推荐课程
export const getLamaRecommends = ({ commit, state }, { courseid = throwIfMissing('课程 id 参数不能为空'), pagesize }) => {
  getApi({ commit }, apis.recommendFree, { courseid, pagesize })
    .then((body) => {
      commit(types.AJAX_GET_LAMA_RECOMMEND, { rs: body.data });
    });
};

// 小时光免费小微课列表
export const getFreeTinyCourseList = ({ commit }, { pagesize = 10, curpage = 1, protocol }) => {
  return getApi({ commit }, apis.freeTinyCourseList, { protocol, pagesize, curpage })
    .then((body) => {
      const freeTinyCourseList = body.data;
      commit(types.AJAX_GET_FREETINYAUDIO, { freeTinyCourseList, curpage });
    });
};

// 用户端 - 根据订单号获取订单详情
export const getQueryByCode = ({ commit }, { code }) => {
  getApi({ commit }, apis.querybycode, { code }, {}, true, false)
    .then((body) => {
      const data = body.data;
      if (data.status) {
        getMaYiPayStatus({ commit }, {
          payInfo: {
            ordernum: code,
            courseId: data.courseId
          },
          status: data.status
        });
      } else {
        console.log('getQueryByCode: 返回数据异常');
      }
    });
};

// todo 重点测试下这里， 看设置的header是否正常
export const getStatus = ({ commit }, { paymentid = throwIfMissing('paymentid 参数不能为空') }) => {
  const params = JSON.stringify({
    oem: window.navigator.userAgent,
    osversion: '9.0',
    screenwidth: window.screen.width,
    screenheight: window.screen.height,
    apptype: '1',
    appversion: '2.0.0',
    nettype: 'unknown',
    regcode: '250',
    provcode: '264',
    partner: 'babytree',
    isHttps: document.location.protocol === 'https:' ? '1' : '0',
    token: window.ajaxHeader.token,
    paymentid
  });
  postApi({ commit }, apis.getStatus, params, { headers: { 'Content-Type': 'application/json' } })
    .then((data) => {
      const code = data.bizCode;
      if (code) {
        getQueryByCode({ commit }, { code });
      }
    }).catch(e => console.log('getStatus: ', e));

  // commit(types.AJAX_LOADING, { loadingStatus: true });
  // api.getStatus({ paymentid }, (err, rs) => {
  //   commit(types.AJAX_LOADING, { loadingStatus: false });
  //   if (err) {
  //     commit(types.AJAX_ERROR, err);
  //   } else {
  //     const data = JSON.parse(rs.text);
  //     const code = data.bizCode;
  //     getQueryByCode({ commit }, { code });
  //   }
  // });
};


// 新版-免费专区
export const getFreeList = ({ commit }, { pagesize = 10, curpage = 1, catagoryid }) => {
  return getApi({ commit }, apis.freeList, { pagesize, curpage, catagoryid })
    .then(data => data);
};
// export const getFreeTinyCourseList = ({ commit }, { protocol, pagesize, curpage }) => {
//   commit(types.AJAX_LOADING, { loadingStatus: true });
//   api.getFreeTinyCourseList({ protocol, pagesize, curpage }, (err, freeTinyCourseList) => {
//     commit(types.AJAX_LOADING, { loadingStatus: false });
//     if (err) {
//       commit(types.AJAX_ERROR, err);
//     } else {
//       commit(types.AJAX_GET_FREETINYAUDIO, { freeTinyCourseList, curpage });
//     }
//   });
// };

/**
 * 首页相关接口
 */
// 新版 - 首页课程收听提示条
export const getCourseRemind = ({ commit }) => {
  return getApi({ commit }, apis.courseRemind).then((body) => {
    const courseRemind = body.data;
    commit(types.COURSE_REMIND, { courseRemind });
    return courseRemind;
  });
};


// 新版 - 首页数据展示
export const getHomePageData = ({ commit }) => {
  // return a promise
  return getApi({ commit }, apis.homePage).then((body) => {
    const pageInfo = body.data;
    commit(types.HOME_INFO, { pageInfo });
    return pageInfo;
  });
  // 对比代码
  // return new Promise((resolve) => {
  //   callApi({ commit }, apis.homePage, params).then((data) => {
  //     commit(types.HOME_INFO, { pageInfo: data });
  //     return resolve(data);
  //   });
  // });
};

// 新版 - 首页为你推荐
export const getRecommend = ({ commit }, { curpage, pagesize }) => {
  return getApi({ commit }, apis.recommend, { curpage, pagesize }).then((body) => {
    commit(types.RECOMMEND_LIST, { recommendList: body.data });
    return body.data;
  });
};

// 新版 - 首页提示条状态
export const setRemindStatus = ({ commit }, { state }) => {
  commit(types.REMIND_CLOSE, { closeStatus: state });
};

// 新版 - 首页热门开讲
export const changeHotCourse = ({ commit }, { state }) => {
  commit(types.CHANGE_HOTCOURSE, { hotCourse: state });
};

// 新版首页 首页模块列表 2018-6-21
export const getIndexModuleList = ({ commit }, { pagesize, curpage, age_type, age_time, platform }) => {
  return getApi({ commit }, apis.indexModuleList, { pagesize, curpage, age_type, age_time, platform }).then((body) => {
    commit(types.INDEX_MODULE_LIST, { indexModuleList: body.data.list });
  });
};

// 新版首页 首页模块列表 获取课程的音频链接
export const getCourseAudioUrl = ({ commit }, { courseid }) => {
  return getApi({ commit }, apis.getCourseAudioUrl, { courseid }).then((body) => {
    return body.data;
  });
};

// 用户端我的课程
export const getMyCourses = ({ commit }, { pagesize = 10, curpage = 1, isquerynostart, indexstart }) => {
  return getApi({ commit }, apis.myCourse, { pagesize, curpage, isquerynostart, indexstart })
    .then((body) => {
      commit(types.AJAX_GET_MYCOURSE, { courseList: body.data });
    });
};
// 试听列表
export const getAudition = ({ commit }, { id, protocol, biztype, type, curpage, pagesize }) => {
  return getApi({ commit }, apis.auditionList, { id, protocol, biztype, curpage, pagesize, type })
    .then((body) => {
      return body.data;
    });
};

// 订阅课子课程列表
export const getSubCourseList = ({ commit }, { id, pagesize, curpage, type, sort, protocol, expertid, labelid, activeid }) => {
  return getApi({ commit }, apis.subCourseList, { id, pagesize, curpage, type, sort, protocol, expertid, labelid, activeid })
    .then((body) => {
      return body.data;
    });
};

// 订阅课子课列表中是否进行了排序
export const setSort = ({ commit }, { state }) => {
  commit(types.IS_SORT, { isSort: state });
};

// 订阅课子课程详情
export const getChildDetail = ({ commit }, { id, protocol, code, isLoading }) => {
  return getApi({ commit }, apis.childDetail, { id, protocol, code }, isLoading)
    .then((body) => {
      const courseInfo = body.data;
      commit(types.AJAX_GET_COURSEINFO, { courseInfo });
      return courseInfo;
    });
};

// 订阅课子课程留言列表
export const getMessageList = ({ commit }, { id, protocol, curpage, pagesize, parentcourseid, type }) => {
  return getApi({ commit }, apis.messageList, { id, protocol, curpage, pagesize, parentcourseid, type })
    .then((body) => {
      const dataList = body.data;
      commit(types.MESSAGE_LIST, { dataList });
      return dataList;
    });
};

// 订阅课列表
export const getColumnList = ({ commit }, { pagesize = 10, curpage = 1, type = 15 }) => {
  return getApi({ commit }, apis.columnList, { pagesize, curpage, type })
    .then((body) => {
      const courseList = body.data;
      commit(types.AJAX_GET_COLUMNLIST, { courseList, curpage });
      // 原方法没返回，增加
      return courseList;
    });
};

// 用户端留言入库
export const setLeaveMessage = ({ commit }, { id, content }) => {
  return getApi({ commit }, apis.setLeaveMessage, { id, content })
    .then((body) => {
      return body.data;
    });
};

// 用户端我的留言
export const getMyGuestBooks = ({ commit }, { id, protocol, pagesize, curpage }) => {
  return getApi({ commit }, apis.myGuestBooks, { id, protocol, pagesize, curpage })
    .then((body) => {
      return body.data;
    });
};
// 用户端删除留言
export const bindDelGuest = ({ commit }, { id }) => {
  return getApi({ commit }, apis.delGuest, { id })
    .then((body) => {
      return body.data;
    });
};
// 点赞/取消点赞 (训练动态/ 用户，精品课留言/回复)
export const bindGiveThumbsup = ({ commit }, { bizid, sourcetype, type }) => {
  return getApi({ commit }, apis.myGuestBooks, { bizid, sourcetype, type })
    .then((body) => {
      return body.data;
    });
};

// 课程详情
export const getNewCourseInfo = ({ commit }, { id, parentcourseid, protocol, code, activeid }) => {
  return getApi({ commit }, apis.newCourseInfo, {
    id,
    parentcourseid,
    protocol,
    code,
    activeid
  }).then((body) => {
    const newCourseInfo = model.newCourse(body.data);
    commit(types.AJAX_GET_NEWCOURSEINFO, { newCourseInfo });
    return newCourseInfo;
  });
};

// 详情页 - 专家列表
export const getCourseExperts = ({ commit }, { curpage, pagesize, id }) => {
  return getApi({ commit }, apis.courseExperts, { curpage, pagesize, id })
    .then((body) => {
      return body.data;
    });
};

// 详情页 - 分类标签列表
export const getClassifyLabel = ({ commit }, { curpage, pagesize, courseid }) => {
  return getApi({ commit }, apis.classifyLabel, { curpage, pagesize, courseid })
    .then((body) => {
      return body.data;
    });
};

// 详情页 - 专家标签列表
export const getExpertsLabel = ({ commit }, { curpage, pagesize, id, type }) => {
  return getApi({ commit }, apis.expertsLabel, { curpage, pagesize, id, type })
    .then((body) => {
      return body.data;
    });
};

// 分销-分享图片生成接口
export const getShareImage = ({ commit }, { id, pid }) => {
  return getApi({ commit }, apis.courseShareImage, { id, pid })
    .then((body) => {
      return body.data;
    });
};

// 我的收益
export const getMyIncome = ({ commit }, { curpage, pagesize }) => {
  return getApi({ commit }, apis.myIncome, { curpage, pagesize })
    .then((body) => {
      commit(types.AJAX_GET_MY_INCOME, {
        curpage,
        myIncome: body.data
      });
    });
};

// 会员免费听
export const getMemberFreeCourse = ({ commit }, { catagoryid, pagesize, curpage }) => {
  return getApi({ commit }, apis.memberFreeCourse, { catagoryid, pagesize, curpage })
    .then((body) => {
      commit(types.AJAX_GET_MEMBER_FREE_COURSE, {
        catagoryid,
        memberFreeCourse: body.data
      });
    });
};

// 会员免费听-非会员广告
export const getMemberAd = ({ commit }, { keys, protocol }) => {
  return getApi({ commit }, apis.getAdverts, { keys, protocol }, {}, true, false)
    .then((body) => {
      return body.data;
    });
};

// 设置VIP 静态数据
export const setVipInfo = ({ commit }, { state }) => {
  commit(types.VIP_INFO, { vipInfo: state });
};

// 奖学金计划详情页
export const getjxjDetails = ({ commit }, { jxjactivityid, curstudytime, protocol }) => {
  return getApi({ commit }, apis.getScholarshipDetail, { jxjactivityid, curstudytime, protocol })
    .then((body) => {
      return body.data;
    });
};

// 弹窗更新提醒接口
export const updateRemind = ({ commit }, { jxjactivityid, remindtype, todaycourseid }) => {
  return getApi({ commit }, apis.updateRemind, { jxjactivityid, remindtype, todaycourseid })
    .then((body) => {
      return body.data;
    });
};

// 奖学金广告位
export const getAdvertsGeneral = ({ commit }, { adkeys, protocol }) => {
  return getApi({ commit }, apis.getAdvertsGeneral, { adkeys, protocol })
    .then((body) => {
      return body.data;
    });
};

// 奖学金计划列表（首页）
export const getScholarshipsList = ({ commit }, { pagenum, pagesize, protocol }) => {
  return getApi({ commit }, apis.getScholarshipsList, { pagenum, pagesize, protocol })
    .then((body) => {
      return body.data;
    });
};

// 查询实名认证状态
export const getCertificate = ({ commit }) => {
  return getApi({ commit }, apis.getcertificate)
    .then((body) => {
      return body.data;
    });
};

// 发送短信验证码
export const getVerifySend = ({ commit }, { verifytype = 1 }) => {
  return getApi({ commit }, apis.getVerifySend, { verifytype })
    .then((body) => {
      return body.data;
    });
};

// 校验短信验证码
export const getVerifyValid = ({ commit }, { verifytype = 1, verifycode }) => {
  return getApi({ commit }, apis.getVerifyValid, { verifytype, verifycode })
    .then((body) => {
      return body.data;
    });
};

// 钱包实名认证
export const getVerified = ({ commit }, { vcode, scene, certificatetype, certificatemode, mobile, bankcard, certificatename, certificatenumber, certificateindate, certificatephoto }) => {
  return getApi({ commit }, apis.getVerified, { vcode, scene, certificatetype, certificatemode, mobile, bankcard, certificatename, certificatenumber, certificateindate, certificatephoto })
    .then((body) => {
      return body.data;
    });
};

// 我的奖学金计划 （我的）
export const getMyListJxjActivity = ({ commit }, { pagenum, pagesize, protocol }) => {
  return getApi({ commit }, apis.getMyListJxjActivity, { pagenum, pagesize, protocol })
    .then((body) => {
      return body.data;
    });
};

// 获取用户信息手机号
export const getUserPhone = ({ commit }) => {
  return getApi({ commit }, apis.getUserPhone)
    .then((body) => {
      return body.data;
    });
};

// 奖学金计划 - 打卡日历
export const getIconList = ({ commit }, { activityid }) => {
  return getApi({ commit }, apis.getIconList, { activityid })
    .then((body) => {
      return body.data || {};
    });
};

// 集赞任务信息
export const getJxjCollectLikes = ({ commit }, { id, openid }) => {
  return getApi({ commit }, apis.getJxjCollectLikes, { id, openid })
    .then((body) => {
      return body.data || {};
    });
};

// 集赞-发起集赞
export const getJxjStartLikes = ({ commit }, { actid }) => {
  return getApi({ commit }, apis.getJxjStartLikes, { actid })
    .then((body) => {
      return body.data || {};
    });
};

// 集赞-点赞
export const getJxjDoLikes = ({ commit }, { taskid, openid, wxap, wxnk }) => {
  return getApi({ commit }, apis.getJxjDoLikes, { taskid, openid, wxap, wxnk })
    .then((body) => {
      return body.data || {};
    });
};

// 打卡信息查询 获取分享图片
export const getPunchCardShare = ({ commit }, { activityid, courseId }) => {
  return getApi({ commit }, apis.getPunchCardShare, { activityid, courseId })
    .then((body) => {
      return body.data || {};
    });
};
// 播放进度发送
export const sendPlayDuration = ({ commit }, { courseid, parentcourseid, audiourl, finish = false, playManyTime }) => {
  // playManyTime 秒 finish 是否是播放完成调用(true:播放完成调用 false:开始播放调用)
  const time = Math.ceil(playManyTime);
  return getApi({ commit }, apis.sendPlayDuration, {
    courseid,
    parentcourseid: parentcourseid || '',
    audiourl,
    finish,
    playManyTime: time
  }, {}, false)
  .then((body) => {
    return body.data || {};
  });
};
// 打卡完成接口
export const getPunchCard = ({ commit }, { activityid, courseId }) => {
  return getApi({ commit }, apis.getPunchCard, { activityid, courseId })
    .then((body) => {
      return body.data || {};
    });
};


/**
 *  专家义诊相关接口
 */

// 获取活动首页相关接口
export const getIndexInfo = ({ commit }, { activityid }) => {
  return getApi({ commit }, apis.getIndexInfo, { activityid })
    .then((body) => {
      return body.data || {};
    });
};

// 获取义诊专家列表
export const getFreeClinicExpert = ({ commit }, { activityid }) => {
  return getApi({ commit }, apis.getFreeClinicExpert, { activityid })
    .then((body) => {
      return body.data || {};
    });
};


// 获取投票排行信息
export const getVoteRankInfo = ({ commit }, { activityid, pagesize, pageno, onlymyquestion }) => {
  return getApi({ commit }, apis.getVoteRankInfo, { activityid, pagesize, pageno, onlymyquestion })
    .then((body) => {
      return body.data || {};
    });
};


export const getUserActivityInfo = ({ commit }, { activityid }) => {
  const enc_user_id = Cookies.get('mtencUserId'); // eslint-disable-line
  return getApi({ commit }, apis.getUserActivityInfo, { activityid, enc_user_id })
  .then((body) => {
    return body.data || {};
  });
};


// 获取免费旁听问题列表
export const canFreeAuditQues = ({ commit }, { activityid, pagesize, currentpage }) => {
  return getApi({ commit }, apis.canFreeAuditQues, { activityid, pagesize, currentpage })
    .then((body) => {
      return body.data || {};
    });
};


// 专家义诊单个问题接口
export const getConsultDetail = ({ commit }, { activityid, questionid, userencodeid }) => {
  return getApi({ commit }, apis.getConsultDetail, { activityid, questionid, userencodeid })
    .then(({ data = {} }) => {
      return data;
    });
};

// 宝宝树上传图片
export const getBabayTreeUploadImg = ({ commit }, { formData, token }) => {
  const localTs = Date.parse(new Date()); // 时间戳
  const signature = `app_id=wapislog=1login_string=${token}timestamp=${localTs}`; // 签名
  const key = '0Qh2hy+z[7ZIv9uvvDJs}gav7BeJ+n50=qNPy9NCunzCaNuns2sq[82]udgPPq=lZ9MEOEUNtmPGkBbPYw+}}NYnNbeMhoHYbwgckMrerp20Gjs24p9506RUiglCFR=y'; // 公钥
  console.log(`${signature}${key}`);
  const secret = crypto.createHash('md5').update(`${signature}${key}`).digest('hex');
  const params = `app_id=wap&signature=${secret}&timestamp=${localTs}&login_string=${token}&islog=1`;
  return postApi({ commit }, `${apis.babayTreeUploadImg}?${params}`, formData, { headers: { 'Content-type': 'multipart/form-data; boundary=Boundary+DE582FBEF6CBC031', timestamp: localTs, signature: secret } })
    .then((data) => {
      if (data.status === true) {
        return data.data;
      }
      Toast(data.message);
      return {};
    });
};

// 宝宝树上传图片 babayTreeUploadImgbase64
export const getBabayTreeUploadImgbase64 = ({ commit }, { formData, token, base64 }) => {
  const localTs = Date.parse(new Date()); // 时间戳
  const base64Str = `data:image/png;base64,${base64}`;
  formData.append('fileArr', base64Str);
  const signature = `app_id=wapislog=1login_string=${token}timestamp=${localTs}`; // 签名
  const key = '0Qh2hy+z[7ZIv9uvvDJs}gav7BeJ+n50=qNPy9NCunzCaNuns2sq[82]udgPPq=lZ9MEOEUNtmPGkBbPYw+}}NYnNbeMhoHYbwgckMrerp20Gjs24p9506RUiglCFR=y'; // 公钥
  console.log(`${signature}${key}`);
  const secret = crypto.createHash('md5').update(`${signature}${key}`).digest('hex');
  const params = `app_id=wap&signature=${secret}&timestamp=${localTs}&login_string=${token}&islog=1`;
  return postApi({ commit }, `${apis.babayTreeUploadImgbase64}?${params}`, formData, { headers: { 'Content-type': 'multipart/form-data; boundary=Boundary+DE582FBEF6CBC031', timestamp: localTs, signature: secret } })
    .then((data) => {
      return data.data;
    });
};

// 专家义诊专家基本信息查询
export const getBaseInfo = ({ commit }, { expertid }) => {
  return getApi({ commit }, apis.getBaseInfo, { expertid })
    .then((data) => {
      return data.data;
    });
};

// 投票接口
export const vote = ({ commit }, { activityid, questionid, sourceid, uid }) => {
  return getApi({ commit }, apis.vote, { activityid, questionid, sourceid, uid })
    .then(({ rtn_code: rtnCode, data: message = '投票失败，请尝试刷新' }) => {
      return { status: +rtnCode, message };
    });
};

// 获取我的问题列表
export const getMyConsultList = ({ commit }, { pagesize = 10, pageno }) => {
  return getApi({ commit }, apis.myConsultList, { pagesize, pageno })
    .then(({ data = [], hasNextPage = true }) => {
      return {
        list: data,
        hasNextPage
      };
    });
};

// 专家义诊用户提问页 questionSubmit
export const questionSubmit = ({ commit }, { activityid, content, photourls, photoids, expertid, categoryid, isanonymous }) => {
  return postApi({ commit }, apis.questionSubmit, { activityid, content, photourls, photoids, expertid, categoryid, isanonymous })
    .then((data) => {
      return data.data;
    });
};
// 投票接口
export const secretToken = (store, { type = 'get', usertoken, encUserId }) => {
  const { commit } = store;
  return getApi({ commit }, apis.secretToken, { type, usertoken, encUserId })
    .then((body) => {
      if (type === 'get') {
        const userInfo = {
          token: body.data.token,
          encUserId: body.data.encUserId
        };
        getMemberInfo(store, userInfo);
      }
      return body.data;
    });
};

// 查询实名认证模式
export const getQueryCertificateType = ({ commit }) => {
  return getApi({ commit }, apis.queryCertificateType)
    .then((data) => {
      return data.data;
    });
};

// 获取课程评价列表页标签列表
export const getCommentTags = ({ commit }, { courseid }) => {
  return getApi({ commit }, apis.commentTags, { courseid })
    .then((data) => {
      return data.data;
    });
};

// 分页获取课程评价及点评列表
export const getCourseComments = ({ commit }, { courseid, tagid, curpage, pagesize }) => {
  return getApi({ commit }, apis.getCourseComments, { courseid, tagid, curpage, pagesize })
    .then((data) => {
      return data.data;
    });
};

// 频道页模块接口
export const getChannelModule = ({ commit }, { age_type, age_time, channel_page, protocol, platform }) => {
  return getApi({ commit }, apis.channelModule, { age_type, age_time, channel_page, protocol, platform })
    .then((data) => {
      return data.data;
    });
};

// 频道页推荐课程接口
export const getChannelRecommend = ({ commit }, { age_type, age_time, module_id, channel_page, protocol, curpage, pagesize, category_id }) => {
  return getApi({ commit }, apis.channelRecommend, { age_type, age_time, module_id, channel_page, protocol, curpage, pagesize, category_id })
    .then((data) => {
      return data.data;
    });
};

// 频道页查询分类列表接口
export const getCategoryList = ({ commit }, { module_id }) => {
  return getApi({ commit }, apis.getCategoryList, { module_id })
    .then((data) => {
      return data.data;
    });
};

// cms广告图
export const getAdByCodes = ({ commit }, { advcode, protocol }) => {
  return getApi({ commit }, apis.adByCodes, { advcode, protocol }, {}, true, false)
    .then((body) => {
      return body.data;
    });
};

// 课程排行榜
export const getCourseRankList = ({ commit }, { curpage, pagesize, ranktype, agetype, agetime, protocol }) => {
  return getApi({ commit }, apis.courseRankList, { curpage, pagesize, ranktype, agetype, agetime, protocol })
    .then((body) => {
      return body.data;
    });
};

// 惠氏 w+会员权益免费听课程列表 wyethCourse
export const getWyethCourse = ({ commit }, { curpage, membertype, protocol }) => {
  return getApi({ commit }, apis.wyethCourse, { curpage, membertype, protocol })
    .then((body) => {
      return body.data;
    });
};

// 惠氏 W+会员自动登录
export const bindWyethLogin = ({ commit }, { name, userId, mobile, birthday, sex, headImgUrl, userExternalType }) => {
  return getApi({ commit }, apis.wyethLogin, { name, userId, mobile, birthday, sex, headImgUrl, userExternalType })
    .then((body) => {
      return body.data;
    });
};

// 树币余额查询
export const queryShubi = ({ commit }, { companyId, encUserId }) => {
  return getApi({ commit }, `${apis.queryBalance}`, { companyId, encUserId })
  .then((data) => {
    commit(types.TREE_COIN_INFO, data.data);
    return data.data;
  });
};

// 树币明细查询
export const queryShubiDetail = ({ commit }, { pageno, companyId, encuid, acttype }) => {
  return getApi({ commit }, `${apis.queryBalanceDetail}`, { pageno, companyId, encuid, acttype })
  .then((data) => {
    commit(types.TREE_COIN_INFO_MORE, data.data);
    return data.data;
  });
};




// WEBPACK FOOTER //
// ./src/store/user/actions.user.js